import { useQuery } from "@tanstack/react-query";
import { getTripadvisorLocationMappings } from "../../api/bReviewsApi";

export const useGetTripadvisorLocationMappings = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["tripadvisor-location-mappings", organisationId],
    queryFn: () => getTripadvisorLocationMappings(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
